// @ is an alias to /src
import MainPage from '@/components/Home/MainPage.vue'
import MainInfo from '@/components/Home/MainInfo.vue'
import dayjs from 'dayjs'

export default {
  name: 'HomeView',
  components: {
    MainPage, MainInfo
  },
  data () {
    return {
      notice: [],
      popList: [],
      modal: false,
      filePath: '',
      today: dayjs().format('YYYY-MM-DD HH:mm')
    }
  },
  async created () {
    this.notice = await this.$get('home/board?commCode=00')
    if (this.notice.detail.length !== 0) {
      for (let i = 0; i < this.notice.detail.length; i++) {
        if (this.notice.detail[i].popStDate !== '' && this.notice.detail[i].popStDate <= this.today && this.notice.detail[i].popEdDate >= this.today) {
          if (!this.$cookies.isKey('popup')) this.modal = true
          this.popList.push(this.notice.detail[i])
        }
      }
    }
  },
  methods: {
    getFileDownloadPath (filePath, fileNm) {
      if (!filePath) {
        return ''
      }

      let normalizedPath = filePath
      if (!normalizedPath.startsWith('/')) {
        normalizedPath = `/${normalizedPath}`
      }

      if (!fileNm) {
        return normalizedPath
      }

      const escapedFileNm = fileNm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const normalizedPathWithoutQuery = normalizedPath.split('?')[0].split('#')[0]

      if (new RegExp(`/${escapedFileNm}$`).test(normalizedPathWithoutQuery)) {
        return normalizedPath
      }

      if (normalizedPath.endsWith('/')) {
        return `${normalizedPath}${fileNm}`
      }

      const hasExtension = /\.[a-zA-Z0-9]+$/.test(normalizedPathWithoutQuery)
      if (!hasExtension) {
        return `${normalizedPath}/${fileNm}`
      }

      return normalizedPath
    },
    buildBoardFileDownloadUrl (filePath, fileNm, fileOrgName) {
      const baseUrl = (this.$store.state.boardFilePath || '').replace(/\/+$/, '')
      if (!baseUrl) return ''

      const mergedPath = this.getFileDownloadPath(filePath, fileNm)
      if (!mergedPath) return ''

      // API 응답에 'file/...'이 들어오는 경우 baseUrl('/files/file')와 중복 방지
      const normalizedMergedPath = mergedPath.replace(/^\/+/, '').replace(/^file\//, '')
      const encodedFileName = encodeURIComponent(fileOrgName || fileNm || '')

      return `${baseUrl}/${normalizedMergedPath}?download=true&fileName=${encodedFileName}`
    },
    isCookie () {
      this.$cookies.remove('popup')
      this.$cookies.set('popup', 'popValue', '1d')
      this.modalClose()
    },
    modalClose () {
      this.modal = false
    }
  }
}
